import React from "react";
import { useDispatch } from "react-redux";
import { pageRoutes } from "../routes/pageRoutes";
import { useLocation, useNavigate } from "react-router-dom";
import { toggleChange } from "../redux/reducers/authReducer";


const Sidebar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const menuItems = [
    {
      title: "Dashboard",
      route: pageRoutes?.newDashBoard,
      icon: "assets/img/dashbaord_icon.svg",
    },
    {
      title: "Users",
      route: pageRoutes?.users,
      icon: "assets/img/user_icon.svg",
    },
    {
      title: "Groups",
      route: pageRoutes?.groups,
      icon: "assets/img/Group_icon.svg",
    },
    {
      title: "User Report",
      route: pageRoutes?.userReport,
      icon: "assets/img/report_icon.svg",
    },
    {
      title: "Group Report",
      route: pageRoutes?.GroupReport,
      icon: "assets/img/group_report_icon.svg",
    },

    // {
    //     title: "Notifications",
    //     route: pageRoutes?.notifications,
    //     icon: "assets/img/notification_icon.svg",
    // },
    {
      title: "Subscriptions",
      route: pageRoutes?.subscriptions,
      icon: "assets/img/subscription_icon.svg",
    },
    {
      title: "Verifications",
      route: pageRoutes?.verifications,
      icon: "assets/img/Vector.svg",
    },
    {
      title: "Notification",
      route: pageRoutes?.notifications,
      icon: "assets/img/iconamoon_notification-bold.svg",
    },
  ];

  return (
    <>
      <div class="ct_side_bar">
        <div
          class="ct_close_menu"
          onClick={() => {
            dispatch(toggleChange(false));
          }}
        >
          <i class="fa-solid fa-xmark"></i>
        </div>
        <div class="ct_logo_admin">
          <img src="assets/img/logo_with_text.svg" alt="" />
        </div>
        <ul className="ct_side_menu">
          {menuItems.map((item, index) => (
            <li key={index}>
              <a
                href="javascript:void(0)"
                className={pathname === item.route ? "active" : ""}
                onClick={() => navigate(item.route)}
              >
                <img src={item.icon} alt={`${item.title} Icon`} />
                {item.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
